import { render } from "./RecipeEdit.vue?vue&type=template&id=a3f05818&scoped=true"
import script from "./RecipeEdit.vue?vue&type=script&lang=js"
export * from "./RecipeEdit.vue?vue&type=script&lang=js"

import "./RecipeEdit.vue?vue&type=style&index=0&id=a3f05818&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a3f05818"

export default script